<div class="sk-lap">
  <div class="sk-fej">
    <img [src]="ikon" alt="">
    <div><h1>{{ gj.aktiv.ugyfelNev || 'Gépjármű' }}</h1>
      <p>Gépjármű – járművek, útnyilvántartás, elszámolás, kiküldetés, költségek és cégautóadó{{ gj.aktiv.szerep === 'konyvelo' ? ' · könyvelői nézet' : '' }}.</p></div>
  </div>
  <p class="gj-figyelem" *ngIf="!gj.aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</p>
  <p class="gj-figyelem" *ngIf="hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ hiba }}</p>

  <ng-container *ngIf="ossz">
    <div class="sk-ossz">
      <div><span>Aktív járművek</span><b>{{ ossz.jarmu }} db</b></div>
      <div><span>Aktív sofőrök</span><b>{{ ossz.sofor }} fő</b></div>
      <div title="Üzleti / magán / munkába járás"><span>Km {{ honapNev }}ban</span><b>{{ szam(ossz.km.osszes, 1) }} km</b>
        <span *ngIf="ossz.km.osszes">üzleti {{ szam(ossz.km.uzleti, 1) }} · magán {{ szam(ossz.km.magan, 1) }}<ng-container *ngIf="ossz.km.munkaba"> · munkába {{ szam(ossz.km.munkaba, 1) }}</ng-container></span></div>
      <div><span>Költség {{ ossz.ev }}-ben (bruttó)</span><b>{{ szam(ossz.koltseg.brutto) }} Ft</b>
        <span *ngIf="ossz.koltseg.uzemanyag">ebből üzemanyag {{ szam(ossz.koltseg.uzemanyag) }} Ft</span></div>
      <div [class.rossz]="ossz.lejaro.lejart" [class.figy]="!ossz.lejaro.lejart && ossz.lejaro.db"><span>Lejáró / lejárt</span>
        <b>{{ ossz.lejaro.db }} tétel</b><span *ngIf="ossz.lejaro.lejart">ebből {{ ossz.lejaro.lejart }} már lejárt</span></div>
    </div>

    <p class="gj-figyelem" *ngIf="!ossz.uzemanyagar_honap">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>Erre a hónapra még nincs rögzítve a NAV üzemanyagára – az elszámolás enélkül nem számol.
        <button type="button" class="ov-link" (click)="nyit('/gepjarmu/beallitasok')">Beállítások → NAV üzemanyagárak</button></span>
    </p>
    <p class="gj-figyelem" *ngIf="!ossz.jarmu_osszes">
      <ion-icon name="car-outline"></ion-icon>
      <span>Még nincs jármű. <button type="button" class="ov-link" (click)="nyit('/gepjarmu/jarmuvek')">Vedd fel az első járművet</button>
        – utána a sofőröket és a címtárat (telephely, partnerek).</span>
    </p>

    <div class="gj-lejaro-lista" *ngIf="ossz.lejaro.db">
      <h3><ion-icon name="alarm-outline"></ion-icon>Lejáró okmányok, biztosítások</h3>
      <a *ngFor="let e of ossz.lejaro.elso" (click)="nyit('/gepjarmu/koltsegek', { ful: 'lejaratok' })">
        <b>{{ e.rendszam || 'Általános' }}</b>
        <span>{{ e.megnevezes || e.fajta_nev }}</span>
        <span class="spacer"></span>
        <span class="sz-allapot" [attr.data-a]="e.allapot === 'lejart' ? 'hiba' : 'figyelmeztetes'">{{ hatra(e) }}</span>
        <span class="halvany">{{ e.ervenyes_ig }}</span>
      </a>
      <a *ngIf="ossz.lejaro.db > ossz.lejaro.elso.length" (click)="nyit('/gepjarmu/koltsegek', { ful: 'lejaratok' })">
        <span class="ov-link">Mind a {{ ossz.lejaro.db }} tétel →</span></a>
    </div>
  </ng-container>

  <div class="sk-racs">
    <button type="button" class="sk-csempe kesz" *ngFor="let c of csempek" (click)="nyit(c.ut)">
      <ion-icon [name]="c.ikon"></ion-icon><div class="sk-szoveg"><b>{{ c.cim }}</b><span>{{ c.leiras }}</span></div>
    </button>
  </div>
</div>
